import { type DeckSource } from "./types";
import { SourceLogo } from "./SourceLogo";

interface SourceHeaderProps {
  source: DeckSource;
}

export function SourceHeader({
  source,
}: SourceHeaderProps) {
  return <div className="flex flex-col items-center mt-4">
    <SourceLogo logoUrl={source.logo_url} size="large" />
    <h4 className="font-semibold text-gray-900">{source.name}</h4>
  </div>
}
